module.exports = __webpack_public_path__ + "img/location.5f7b9b4e.svg";